import type { ModuleComponentProps } from '@/lib/module-registry'
import type { MetricModuleData } from '@/types/task'

export function MetricInputComponent({
  value,
  onChange,
  readOnly,
}: ModuleComponentProps<'metric'>) {
  const num = value?.value

  if (readOnly) {
    return (
      <span className="text-sm font-medium tabular-nums">
        {num !== undefined && num !== null
          ? num.toLocaleString('id-ID')
          : '—'}
      </span>
    )
  }

  return (
    <input
      type="number"
      value={num ?? ''}
      onChange={(e) => {
        const parsed = parseFloat(e.target.value)
        onChange({ value: isNaN(parsed) ? 0 : parsed } as MetricModuleData)
      }}
      placeholder="0"
      className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-ring"
    />
  )
}
